import { MdInfoOutline, MdOutlineWavingHand, MdPersonOutline } from "react-icons/md"
import { Container, FirstGrid, Header, BillingSelect, CloseInvoiceBtn, HeaderSeparation } from "./styles"
import { useContext, useEffect, useState } from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import formatCurrency from "../../../../utils/formatCurrency";
import { BillingCard } from "../../components/billing-card";
import { Modal } from "../../../../components/modal";
import { BillingTable } from "../../components/billing-table";
import { closeBilling, overview } from "../../../../services/billing-admin-overview.service";
import { Calendar } from "primereact/calendar";
import SystemContext from "../../../../../context/systemContext/context";
import { ICommonTestComponent } from "../../../../models/ICommonTestComponent";



export const Billing: React.FC<ICommonTestComponent> = ({ jestFunc = () => {}, testMode = false }) => {
    const d = new Date()
    const { t: translation } = useTranslation()
    const { systemConfig } = useContext(SystemContext)

    const [formattedDate, setFormattedDate] = useState<string>('06-22')
    const [month, setMonth] = useState(d.getMonth() + 1)
    const [date, setDate] = useState<any>(d);
    const [currentMonth] = useState(d.getMonth() + 1)
    const [isLoading, setIsLoading] = useState(false)
    const [ id, setId] = useState<number>(0)
    const [closedInvoiceDate, setClosedInvoiceDate] = useState<Date>()
    const [transfer, setTransfer] = useState(0)
    const [totalSubs, setTotalSubs] = useState<number>(0)
    const [aggregate, setAggregate] = useState<number>(0)
    const [perMaterialValue, setPerMaterialValue] = useState(50)
    const [isInvoiceClosed, setIsInvoiceClosed] = useState(false)
    const [isModalShow, setIsModalShow] = useState(false)
    const [partners, setPartners] = useState<any[]>([])

    useEffect(() => { 
        if(date) {  
            let j = date as Date
            setMonth(j.getMonth() + 1)
            setFormattedDate(`${j.getMonth() + 1}-${j.getFullYear().toString().substr(2)}`)
        }
        
    }, [date])

    useEffect(() => {
        setIsLoading(true);
        
        overview(formattedDate).then((res) => {
            setAggregate(res.accumulated || 0)
            setIsInvoiceClosed(res.is_closed)
            setTotalSubs(res.signatures || 0)
            setTransfer(res.transfer_estimate || 0)
            setPerMaterialValue(res.value_per_material || 0)
            setPartners(res.partners || [])
            setId(res.id || 0)

            setClosedInvoiceDate(() => {
                let k = new Date(res.finished_at)
                return  k
            })

            setIsLoading(false);
        }).catch(() => setIsLoading(false))
    }, [formattedDate])

    const closeInvoice = () => {
        setIsLoading(true)
        closeBilling(id).then((res) => { 
            setIsInvoiceClosed(true)
            setClosedInvoiceDate(d)
            setIsLoading(false)
            setIsModalShow(false)
            toast.success("Repasse realizado com sucesso !", {
                position: toast.POSITION.BOTTOM_CENTER,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
                pauseOnHover: false,
                closeButton: false,
                autoClose: 2600,
            });
        }).catch(() => setIsLoading(false))
    }

    const openModal = () => {
        jestFunc('openModal')
        setIsModalShow(true)
    }

    const hideModal = () => {
        setIsModalShow(false)
    }

    const tableColumns = [
        {field:"name", header:translation('contactForm.labelName'), sortable: true},

        {field:"materials_used", headerStyle:{ justifyContent: 'center' }, bodyStyle:{ justifyContent: 'center', fontWeight: 400 }, 
        header:translation('manager.dashboard.secondChart.title'), sortable:true},

        {field:"external_access", headerStyle:{ justifyContent: 'center' }, bodyStyle:{ justifyContent: 'center', fontWeight: 400 },
         header:translation('manager.dashboard.secondChart.firstLabel'), sortable:true},

        {field:"transfer_estimate" , headerStyle:{ justifyContent: 'center' }, bodyStyle:{ justifyContent: 'center', fontWeight: 700 },
         header:translation('manager.billing.transferValue'), sortable:true, isMoney:true}
    ]

    return (
        <Container>
            <Header>
                <HeaderSeparation style={{ alignItems: 'flex-end' }}>
                    <h1>{translation('manager.billing.title')}</h1>
                    <span>{translation('manager.billing.reference')}: 01/{month < 10 ? `0${month}` : month}/{d.getFullYear()} - {month === 2 ? '28' : month % 2 ? '31' : '30'}/{month < 10 ? `0${month}` : month}/{d.getFullYear()}</span>
                </HeaderSeparation>
                <HeaderSeparation style={{ alignItems: 'center' }}>
                    <div style={{ marginRight: 20}}>
                        <BillingSelect>
                            <span>{translation('manager.billing.selectEpoch')}</span>
                            <Calendar inputStyle={{  height: 35  }} id="monthpicker" value={date} onChange={(e: any) => setDate(e.value)} view="month" dateFormat="mm/y" />
                        </BillingSelect>
                    </div>
                    {isInvoiceClosed && (<span style={{ marginLeft: 10 }}> {translation('manager.billing.closedBilling')} <MdInfoOutline style={{ marginLeft: 10 }} /></span>)}
                    {currentMonth <= month && !isInvoiceClosed && (
                        <OverlayTrigger placement={'bottom'} overlay={
                            <Tooltip>{translation('manager.billing.closeInvoiceWarning')}</Tooltip>
                        } >
                            <CloseInvoiceBtn type="button"  isDisabled > {translation('manager.billing.closeInvoice')} </CloseInvoiceBtn>
                        </OverlayTrigger>
                    )}
                    {((currentMonth > month && !isInvoiceClosed) || testMode) && (<CloseInvoiceBtn type="button" isDisabled={false} data-testid="buttonToOpenModal" onClick={openModal}> {translation('manager.billing.closeInvoice')} </CloseInvoiceBtn>)}

                </HeaderSeparation>
            </Header>
            <FirstGrid>
                <BillingCard
                    isLoading={isLoading}
                    label={translation('manager.billing.totalSubs')}
                    value={totalSubs}
                    color={isInvoiceClosed || totalSubs === 0 ? "#CCCCCC" : "#6473FF"}
                    icon={<MdPersonOutline size={38} />} 
                />
                <BillingCard
                    isLoading={isLoading}
                    label={translation('manager.billing.partners')}
                    value={partners.length}
                    color={isInvoiceClosed || partners.length === 0 ? "#CCCCCC" : "#F39035"}
                    icon={<MdOutlineWavingHand size={38}/>}
                />
                <BillingCard
                    isLoading={isLoading}
                    label={translation('manager.billing.aggregate')}
                    value={aggregate}
                    color={isInvoiceClosed || aggregate === 0 ? "#CCCCCC" : "#37C896"}
                    isMoney
                    hasVisibleToggle
                    visibleValue={systemConfig.showBalance}
                />
                <BillingCard
                    isLoading={isLoading}
                    label={translation('manager.billing.transfer')}
                    value={transfer}
                    color={isInvoiceClosed || transfer === 0 ? "#CCCCCC" : currentMonth <= month ? '#FFB70D' : '#6473FF'}
                    isMoney
                    hasVisibleToggle
                    visibleValue={systemConfig.showTransfer}
                />

            </FirstGrid>
            {isLoading ? (
                <div className="loading-container mt-5">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : (
                <main>
                    <BillingTable  itens={partners} columns={tableColumns} emptyMessage="Você não possui nenhum parceiro ainda"/>
                    {isInvoiceClosed && closedInvoiceDate && (
                        <div style={{ textAlign: 'end', marginTop: 20, marginBottom: 20 }}>
                            <span >{translation('manager.billing.closedInvoice')}: {`${closedInvoiceDate.getDate()}/${closedInvoiceDate.getMonth() + 1 < 10 ? `0${closedInvoiceDate.getMonth() + 1}` : closedInvoiceDate.getMonth() + 1}/${closedInvoiceDate.getFullYear()}`}</span>
                        </div>
                    )}
                </main>
            )}

            <Modal
                loading={isLoading}
                show={isModalShow}
                size="lg"
                submitButtonText={translation('manager.user.confirm')}
                variant="confirm-modal-default"
                onSubmit={closeInvoice}
                onHide={hideModal}
                hasDefaultIcon={false}
                headerTitle={translation('manager.billing.warning')} >

                <div style={{ paddingLeft: 27 + "%" }}>
                    <p style={{ textAlign: 'left' }}>{translation('manager.billing.modalMessage1')}<b>{translation(`manager.dashboard.filterChart.months.${month}`)}</b> {translation('manager.billing.modalMessage2')}?</p>

                    <p style={{ textAlign: 'left' }}>{translation('manager.billing.transferValue')}: <b>{formatCurrency(transfer)}</b></p>

                    <p style={{ textAlign: 'left' }}>{translation('manager.billing.materialValue')}: <b>{formatCurrency(perMaterialValue)}</b></p>

                    <p style={{ textAlign: 'left' }}>{translation('manager.billing.totalPartners')}: <b>{partners.length}</b></p>
                </div>
            </Modal>


        </Container>
    )
}